(function() {
  'use strict';

  angular
    .module('iqxCore')
    .service('dataSvc', dataSvc)

  function dataSvc(){
    var svc = this

    svc.favourites = {}
    svc.reset = reset

    reset()

    ///////////

    function reset(){
      delete svc.favourites; svc.favourites = {}
    }

  }

})()